// Libs
import React, { useContext } from 'react';
// Components
import { Span } from 'components';
// Context
import { ElementViewBuilderContext } from 'core/context';
// Config
import { ElementViewBuilderConfig } from 'core/ElementViewBuilder';

export const hasPaymentLines = value => {
	if (typeof value === 'string' && value.includes('/')) {
		return value.split('/').some(quantity => Number(quantity) > 0);
	}

	return Number(value) > 0;
};

const LinesQuantity = ({
	field,
	paid_to,
	elementId,
	name,
	paycut_id,
	isPaymentSigned,
	isPaymentOpen,
	linesQuantityValue,
	disableOverview,
}) => {
	const { setElementView } = useContext(ElementViewBuilderContext);
	const elementViewKeys =
		ElementViewBuilderConfig.getAuthorizedElementViewKeys();
	const hasNoLines = !hasPaymentLines(linesQuantityValue);

	const handleOpenOverview = e => {
		if (disableOverview || hasNoLines) return;

		const overviewPayload = {
			elementId,
			paid_to,
			name,
			paycut_id,
			isPaymentSigned,
			isPaymentOpen,
		};

		if (typeof field.onClick === 'function') {
			field.onClick(overviewPayload);
			e.stopPropagation();
			return;
		}

		e.stopPropagation();
		setElementView({
			elementViewKey:
				elementViewKeys.BILLING_PAYMENT_PAYCUT_DETAILS_REQUEST_ELEMENT,
			elementId: paycut_id || elementId,
			paycutId: paycut_id,
			isInvoice: true,
			initialView: {
				tabKey: 'linesKey',
				linesOnly: true,
				readOnly: true,
				canManageLines: false,
				titleTab: name || '',
				fechtData: {
					paymentId: elementId,
					paid_to,
					paycut_id,
					isPaymentSigned,
					isPaymentOpen,
				},
			},
		});
	};

	return (
		<Span
			hoverable={!hasNoLines && !disableOverview}
			onClick={hasNoLines ? undefined : handleOpenOverview}
		>
			{linesQuantityValue}
		</Span>
	);
};
export default LinesQuantity;
